import { CommonModule } from "@angular/common";
import { Component, inject, input, Input } from "@angular/core";
import { IconModule } from "@shared/components/icon/icon.module";
import { FeatureFlagCodes } from "@shared/constants/feature-flag-codes";
import { PayGroup } from "@shared/models/pay-groups";
import { FeatureManagementService } from "@shared/services/feature-management/feature-management.service";
import { getOffsetFromLegalEntityTimezone, setupUTCOffset, timeZoneAbbreviation } from "@shared/utils/date.util";
import { take } from "rxjs";

@Component({
	selector: "app-legal-entity-timezone-disclaimer",
	templateUrl: "./legal-entity-timezone-disclaimer.component.html",
	styleUrls: ["./legal-entity-timezone-disclaimer.component.scss"],
	standalone: true,
	imports: [IconModule, CommonModule]
})
export class LegalEntityTimezoneDisclaimerComponent {
	paygroup!: PayGroup;
	date!: Date;
	@Input() set payGroup(pg: PayGroup) {
		this.paygroup = pg;

		if (this.date) {
			this.setupOffset(pg, this.date);
		}
	}

	@Input() set milestoneDate(date: Date) {
		this.date = date;
		if (this.paygroup) {
			this.setupOffset(this.paygroup, date);
		}
	}
	timeZoneShort = timeZoneAbbreviation();
	isGlobalDashboard = input<boolean>(false);
	textMessage = input<string>("");
	fullTimeZone = "";
	localTimeZone = "";
	hasTimezoneFeature = false;

	private featureManagementService = inject(FeatureManagementService);

	constructor() {
		this.localTimeZone = `${this.timeZoneShort} (UTC${setupUTCOffset()})`;

		this.featureManagementService
			.hasFeature(FeatureFlagCodes.Q3_TIMEZONE_FE)
			.pipe(take(1))
			.subscribe(hasFeature => (this.hasTimezoneFeature = hasFeature));
	}

	setupOffset(paygroup: PayGroup, date: Date) {
		const timezone = paygroup.legalEntity.data.timeZone;
		const timeZoneOffset = getOffsetFromLegalEntityTimezone(timezone, date);
		let timeZoneUTC = "UTC";

		if (timeZoneOffset > 0) {
			timeZoneUTC = `UTC+${timeZoneOffset}`;
		} else if (timeZoneOffset < 0) {
			timeZoneUTC = `UTC${timeZoneOffset}`;
		}

		this.fullTimeZone = this.timeZoneShort + ` (${timeZoneUTC})`;
	}

	formatTimezone(timezone: string): string {
		const parts = timezone.split("/");
		return `${parts[1]}, ${parts[0]}`;
	}
}
